import React from "react"

function Car({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 14.6667L12.7682 16.5568C12.918 16.6817 13.1068 16.75 13.3017 16.75H22.6982C22.8932 16.75 23.082 16.6817 23.2317 16.5568L25.5 14.6667M13.4167 19.6667H13.425M22.5833 19.6667H22.5917M14.8005 11.75H21.1995C21.7976 11.75 22.3498 12.0705 22.6465 12.5898L25.0608 16.8147C25.3486 17.3184 25.5 17.8884 25.5 18.4686V23.4167C25.5 23.8769 25.1269 24.25 24.6667 24.25H23.8333C23.3731 24.25 23 23.8769 23 23.4167V22.5833H13V23.4167C13 23.8769 12.6269 24.25 12.1667 24.25H11.3333C10.8731 24.25 10.5 23.8769 10.5 23.4167V18.4686C10.5 17.8884 10.6514 17.3184 10.9392 16.8147L13.3535 12.5898C13.6502 12.0705 14.2024 11.75 14.8005 11.75ZM13.8333 19.6667C13.8333 19.8967 13.6468 20.0833 13.4167 20.0833C13.1865 20.0833 13 19.8967 13 19.6667C13 19.4366 13.1865 19.25 13.4167 19.25C13.6468 19.25 13.8333 19.4366 13.8333 19.6667ZM23 19.6667C23 19.8967 22.8134 20.0833 22.5833 20.0833C22.3532 20.0833 22.1667 19.8967 22.1667 19.6667C22.1667 19.4366 22.3532 19.25 22.5833 19.25C22.8134 19.25 23 19.4366 23 19.6667Z"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Car
